export default "__VITE_ASSET__4jEGucp7__"